<template>
    <div class="EntityDetailsPropertiesTabToolbar">
        <transition name="EntityDetailsPropertiesTab__toolbarFade" mode="out-in">
            <div v-if="!isEditing" key="view" class="EntityDetailsPropertiesTab__toolbarActions">
                <NewButton
                    v-if="!isDisabledByRbac"
                    variant="fill"
                    color="primary"
                    class="EntityDetailsPropertiesTab__toolbarBtn"
                    :disabled="!entityActive"
                    :title="!entityActive ? 'This entity is inactive and cannot be edited' : undefined"
                    @click="$emit('edit')"
                >
                    <EidIcon
                        :icon-src="faPenToSquare"
                        alt="edit"
                        class="EntityDetailsPropertiesTab__editBtnIcon"
                    />
                    Edit Entity Details
                </NewButton>
            </div>
            <div v-else key="edit" class="EntityDetailsPropertiesTab__toolbarActions">
                <NewButton
                    variant="flat"
                    color="neutral"
                    class="EntityDetailsPropertiesTab__cancelBtn"
                    @click="$emit('cancel')"
                >
                    Cancel
                </NewButton>
                <NewButton
                    variant="fill"
                    color="primary"
                    :loading="loading"
                    @click="$emit('save')"
                >
                    Save
                </NewButton>
            </div>
        </transition>
    </div>
</template>

<style lang="scss">
.EntityDetailsPropertiesTabToolbar {
    grid-column: 1 / -1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-bottom: 4px;
}

.EntityDetailsPropertiesTab {
    &__toolbarFade {
        &-enter-active,
        &-leave-active {
            transition: opacity 0.15s ease;
        }

        // PRODUCT-26110 Task 12b (TRANSITION_CLASSES): Vue 3 renamed the v2 `X-enter`
        // class to `X-enter-from` (still combined with `X-enter-active` during the
        // enter phase); `X-leave-to` is unchanged between v2 and v3.
        &-enter-from,
        &-leave-to {
            opacity: 0;
        }
    }

    &__toolbarActions {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    &__toolbarBtn {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 13px;
        font-weight: 500;
    }

    &__cancelBtn {
        color: var(--eidQualityBlack-50);
        font-size: 13px;

        &:hover {
            color: var(--eidQualityBlack);
            background: transparent;
        }
    }
}
</style>

<script lang="ts">
    import { defineComponent } from 'vue';

    import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';

    import NewButton from '@/components/new-button/NewButton.vue';

    export default defineComponent({
        name: 'EntityDetailsPropertiesTabToolbar',
        components: { EidIcon, NewButton },
        props: {
            isEditing: {
                type: Boolean,
                required: true,
            },
            loading: {
                type: Boolean,
                required: true,
            },
            entityActive: {
                type: Boolean,
                required: true,
            },
            isDisabledByRbac: {
                type: Boolean,
                required: true,
            },
        },
        emits: [ 'cancel', 'edit', 'save' ],
        data() {
            return { faPenToSquare };
        },
    });
</script>
